import React, { Component } from 'react'
import Preview from './Preview'


export default class MovieTrack extends Component {
    
    state = {
        track : 0,
        numberPerTrack : "",
        proprety : "",
        properties : "",
        height: window.innerHeight,
        width: window.innerWidth
    }
    
    next = () => {
        this.setState(prevState => {
            const numPerTrack = (window.innerWidth > 1100) 
            ? 4 
            : (window.innerWidth > 800) 
                ? 3 
                : (window.innerWidth > 600)
                ? 2
                : 1;
            return {
                properties : this.state.proprety.slice(((prevState.track + 1) * prevState.numberPerTrack) ,
                (prevState.track + 1) * prevState.numberPerTrack + numPerTrack),
                track : prevState.track + 1
            }
        })
        console.log(this.state)
    }

    previous = () => {
        this.setState(prevState => {
            const numPerTrack = (window.innerWidth > 1100) 
            ? 4 
            : (window.innerWidth > 800) 
                ? 3 
                : (window.innerWidth > 600)
                ? 2 
                : 1;

            return {
                properties : this.state.proprety.slice(((prevState.track - 1) * prevState.numberPerTrack) ,
                (prevState.track - 1) * prevState.numberPerTrack + numPerTrack),
                track : prevState.track - 1
            }
        })
    }


    debounce = (fn, ms) => {
        let timer
        return _ => {
          clearTimeout(timer)
          timer = setTimeout(_ => {
            timer = null
            fn.apply(this)
          }, ms)
        };
      }

      
    
    render() {

        console.log(this.props.genreList)

        if (this.state.properties == "") {
                return <div>Vacio</div>
        } else {

            return (


                <div className= "movieTrack">


                <h1>{this.props.genre}</h1>
                <div className="previewWraper">
                    <button
                        className = "navButton left" 
                        onClick = {this.previous}
                        disabled = {(this.state.track == 0) ? true : false}>
                        <span className="fas fa-chevron-left"></span>
                    </button>
                    <button 
                        className = "navButton right" 
                        onClick = {this.next}
                        disabled = {(this.state.track == ((window.innerWidth < 900) ? 8 : 4) ? true : false)}>
                        <span className="fas fa-chevron-right"></span>
                    </button>

                    {this.state.properties.map((item, index) => {
                        const {vote_count, poster_path, backdrop_path, original_title, genre_ids, vote_average, overview, release_date} = item;

                        return <Preview
                            key = {index}
                            vote = {vote_count}
                            poster = {poster_path}
                            backdrop = {backdrop_path}
                            title = {original_title}
                            genre = {genre_ids}
                            genreList = {this.props.genreList}
                            rating = {vote_average}
                            overview = {overview}
                            release = {release_date}
                        />


                    })}
                </div>

                </div>
            )
        }

    }


    componentDidMount() {
        // const key = "21f53417a5404d2ee865b5d4641ec478"
        // const queryValue = `https://api.themoviedb.org/3/movie/popular?api_key=${key}&language=en-US&page=1`

        const queryValue = this.props.linkGenre

        const query = fetch(queryValue)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    proprety : data.results,
                    // properties : (window.innerWidth < 900) ? data.results.slice(0,2) : data.results.slice(0,4) ,
                    properties : (window.innerWidth > 1100) 
                    ? data.results.slice(0,4) 
                    : (window.innerWidth > 800) 
                        ? data.results.slice(0,3) 
                        : (window.innerWidth > 600)
                        ? data.results.slice(0,2) 
                        : data.results.slice(0,1),
                    numberPerTrack : (window.innerWidth > 1100) 
                    ? 4 
                    : (window.innerWidth > 800) 
                        ? 3 
                        : (window.innerWidth > 600)
                        ? 2 
                        : 1,
                    
                })
            });

        const debounce = (fn, ms) => {
                let timer
                return _ => {
                  clearTimeout(timer)
                  timer = setTimeout(_ => {
                    timer = null
                    fn.apply(this)
                  }, ms)
                };
              }

        const debouncedHandleResize = debounce(function handleResize() {
            this.setState((prevState) => {
                const firstOfTrack = prevState.track * prevState.numberPerTrack;
                return {
                properties : (window.innerWidth > 1100) 
                    ? this.state.proprety.slice(firstOfTrack, firstOfTrack + 4) 
                    : (window.innerWidth > 800)
                        ? this.state.proprety.slice(firstOfTrack, firstOfTrack + 3)
                        : (window.innerWidth > 600)                        
                        ? this.state.proprety.slice(firstOfTrack, firstOfTrack + 2)
                        : this.state.proprety.slice(firstOfTrack, firstOfTrack + 1), 
                numberPerTrack : (window.innerWidth > 1100) 
                    ? 4 
                    : (window.innerWidth > 800) 
                        ? 3 
                        : (window.innerWidth > 600)
                        ? 2 
                        : 1,
                height: window.innerHeight,
                width: window.innerWidth
            }

            })
            }, 400)

        window.addEventListener('resize', debouncedHandleResize)
    }

}





